// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActionFiringMode } from "./action-firing-mode";
import { ContactInfo, ContactInfoT, verifyContactInfo } from "./contact-info";
import {
  RoleBankPermission,
  RoleBankPermissionT,
  verifyRoleBankPermission,
} from "./role-bank-permission";
import {
  RoleFloorPermission,
  RoleFloorPermissionT,
  verifyRoleFloorPermission,
} from "./role-floor-permission";
import {
  RoleLiftPermission,
  RoleLiftPermissionT,
  verifyRoleLiftPermission,
} from "./role-lift-permission";
import { RoleMenu, RoleMenuT, verifyRoleMenu } from "./role-menu";
import { UserStatus } from "./user-status";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * User account record.
 */
export class User implements flatbuffers.IUnpackableObject<UserT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): User {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUser(bb: flatbuffers.ByteBuffer, obj?: User): User {
    return (obj || new User()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUser(bb: flatbuffers.ByteBuffer, obj?: User): User {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new User()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  roleId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  cognitoId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  prefGridId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  email(): string;
  email(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  email(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  firstName(): string | null;
  firstName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  firstName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  middleName(): string | null;
  middleName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  middleName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  lastName(): string | null;
  lastName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  status(): UserStatus {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : UserStatus.NEW;
  }

  prefTheme(): string | null;
  prefTheme(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  prefTheme(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Argon2-hashed password for offline mode authentication.
   * Scrubbed on export when `ScrubCreds` is enabled.
   */
  offlinePsw(): string | null;
  offlinePsw(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  offlinePsw(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  acceptedTerms(): string | null;
  acceptedTerms(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  acceptedTerms(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded schedule preferences.
   */
  scheduleJson(): string | null;
  scheduleJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  scheduleJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdOfflinePsw(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  commandNotifications(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  globalNotifications(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OrgType string for the user's organization (e.g. "MASTER", "ORG", "SUBORG").
   * Populated when the organization is preloaded alongside the user.
   */
  orgType(): string | null;
  orgType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  orgType(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Display name of the user's organization. Populated when Organization is preloaded.
   */
  orgName(): string | null;
  orgName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  orgName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Display name of the user's role. Populated when Role is preloaded.
   */
  roleName(): string | null;
  roleName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  roleName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Structured role menu for permissions. Populated when Role is preloaded
   * on /users/me and /users/terms endpoints.
   */
  roleMenu(obj?: RoleMenu): RoleMenu | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset
      ? (obj || new RoleMenu()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Contact info supplied on user create/update requests. Reuses the
   * ContactInfo table; on create only phone/phone_code/address/priority are
   * read by the server (id/user_id are placeholders supplied by the client
   * to satisfy ContactInfo's required fields).
   */
  contactInfo(index: number, obj?: ContactInfo): ContactInfo | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset
      ? (obj || new ContactInfo()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  contactInfoLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Effective per-bank scope grants for this user's role, denormalized for
   * /users/me and /users/terms. The User payload carries role_menu but NOT
   * a nested Role, so the enforcement layer reads its scope grants here.
   * These are the role's EFFECTIVE grants (own rows, or inherited from
   * `base_role` when the role defines none for that class). Empty vector =
   * access to all banks (default enforced by consumers). Appended at end of
   * table for `FlatBuffer` wire compatibility.
   */
  bankPermissions(index: number, obj?: RoleBankPermission): RoleBankPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset
      ? (obj || new RoleBankPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Effective per-lift scope grants for this user's role. Empty = all lifts.
   */
  liftPermissions(index: number, obj?: RoleLiftPermission): RoleLiftPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset
      ? (obj || new RoleLiftPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Effective per-floor scope grants for this user's role. Empty = all floors.
   */
  floorPermissions(index: number, obj?: RoleFloorPermission): RoleFloorPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset
      ? (obj || new RoleFloorPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  floorPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * This user's override of the organization's action firing mode.
   *
   * INHERIT -- the default, and the zero value -- means the organization's
   * setting applies. Only an administrator may set this to an explicit
   * value, and doing so for ANOTHER user is a separate permission from
   * doing it for yourself.
   *
   * Read it through the server's resolver rather than directly: a client
   * that reads this field alone sees INHERIT and cannot tell what the user
   * will actually get.
   */
  actionFiringMode(): ActionFiringMode {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionFiringMode.INHERIT;
  }

  static startUser(builder: flatbuffers.Builder) {
    builder.startObject(29);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addRoleId(builder: flatbuffers.Builder, roleIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, roleIdOffset, 0);
  }

  static addCognitoId(builder: flatbuffers.Builder, cognitoIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, cognitoIdOffset, 0);
  }

  static addPrefGridId(builder: flatbuffers.Builder, prefGridIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, prefGridIdOffset, 0);
  }

  static addEmail(builder: flatbuffers.Builder, emailOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, emailOffset, 0);
  }

  static addFirstName(builder: flatbuffers.Builder, firstNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, firstNameOffset, 0);
  }

  static addMiddleName(builder: flatbuffers.Builder, middleNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, middleNameOffset, 0);
  }

  static addLastName(builder: flatbuffers.Builder, lastNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, lastNameOffset, 0);
  }

  static addStatus(builder: flatbuffers.Builder, status: UserStatus) {
    builder.addFieldInt8(9, status, UserStatus.NEW);
  }

  static addPrefTheme(builder: flatbuffers.Builder, prefThemeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, prefThemeOffset, 0);
  }

  static addOfflinePsw(builder: flatbuffers.Builder, offlinePswOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, offlinePswOffset, 0);
  }

  static addAcceptedTerms(builder: flatbuffers.Builder, acceptedTermsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, acceptedTermsOffset, 0);
  }

  static addScheduleJson(builder: flatbuffers.Builder, scheduleJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, scheduleJsonOffset, 0);
  }

  static addCreatedOfflinePsw(builder: flatbuffers.Builder, createdOfflinePsw: boolean) {
    builder.addFieldInt8(14, +createdOfflinePsw, +false);
  }

  static addCommandNotifications(builder: flatbuffers.Builder, commandNotifications: boolean) {
    builder.addFieldInt8(15, +commandNotifications, +true);
  }

  static addGlobalNotifications(builder: flatbuffers.Builder, globalNotifications: boolean) {
    builder.addFieldInt8(16, +globalNotifications, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, deletedAtOffset, 0);
  }

  static addOrgType(builder: flatbuffers.Builder, orgTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, orgTypeOffset, 0);
  }

  static addOrgName(builder: flatbuffers.Builder, orgNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, orgNameOffset, 0);
  }

  static addRoleName(builder: flatbuffers.Builder, roleNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(22, roleNameOffset, 0);
  }

  static addRoleMenu(builder: flatbuffers.Builder, roleMenuOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, roleMenuOffset, 0);
  }

  static addContactInfo(builder: flatbuffers.Builder, contactInfoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(24, contactInfoOffset, 0);
  }

  static createContactInfoVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startContactInfoVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankPermissions(
    builder: flatbuffers.Builder,
    bankPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(25, bankPermissionsOffset, 0);
  }

  static createBankPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLiftPermissions(
    builder: flatbuffers.Builder,
    liftPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(26, liftPermissionsOffset, 0);
  }

  static createLiftPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addFloorPermissions(
    builder: flatbuffers.Builder,
    floorPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(27, floorPermissionsOffset, 0);
  }

  static createFloorPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFloorPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActionFiringMode(builder: flatbuffers.Builder, actionFiringMode: ActionFiringMode) {
    builder.addFieldInt8(28, actionFiringMode, ActionFiringMode.INHERIT);
  }

  static endUser(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // org_id
    builder.requiredField(offset, 8); // role_id
    builder.requiredField(offset, 14); // email
    return offset;
  }

  unpack(): UserT {
    return new UserT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.roleId() !== null ? this.roleId()!.unpack() : null,
      this.cognitoId() !== null ? this.cognitoId()!.unpack() : null,
      this.prefGridId() !== null ? this.prefGridId()!.unpack() : null,
      this.email(),
      this.firstName(),
      this.middleName(),
      this.lastName(),
      this.status(),
      this.prefTheme(),
      this.offlinePsw(),
      this.acceptedTerms(),
      this.scheduleJson(),
      this.createdOfflinePsw(),
      this.commandNotifications(),
      this.globalNotifications(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.orgType(),
      this.orgName(),
      this.roleName(),
      this.roleMenu() !== null ? this.roleMenu()!.unpack() : null,
      this.bb!.createObjList<ContactInfo, ContactInfoT>(
        this.contactInfo.bind(this),
        this.contactInfoLength(),
      ),
      this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.bankPermissions.bind(this),
        this.bankPermissionsLength(),
      ),
      this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.liftPermissions.bind(this),
        this.liftPermissionsLength(),
      ),
      this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.floorPermissions.bind(this),
        this.floorPermissionsLength(),
      ),
      this.actionFiringMode(),
    );
  }

  unpackTo(_o: UserT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    _o.cognitoId = this.cognitoId() !== null ? this.cognitoId()!.unpack() : null;
    _o.prefGridId = this.prefGridId() !== null ? this.prefGridId()!.unpack() : null;
    _o.email = this.email();
    _o.firstName = this.firstName();
    _o.middleName = this.middleName();
    _o.lastName = this.lastName();
    _o.status = this.status();
    _o.prefTheme = this.prefTheme();
    _o.offlinePsw = this.offlinePsw();
    _o.acceptedTerms = this.acceptedTerms();
    _o.scheduleJson = this.scheduleJson();
    _o.createdOfflinePsw = this.createdOfflinePsw();
    _o.commandNotifications = this.commandNotifications();
    _o.globalNotifications = this.globalNotifications();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.orgType = this.orgType();
    _o.orgName = this.orgName();
    _o.roleName = this.roleName();
    _o.roleMenu = this.roleMenu() !== null ? this.roleMenu()!.unpack() : null;
    _o.contactInfo = this.bb!.createObjList<ContactInfo, ContactInfoT>(
      this.contactInfo.bind(this),
      this.contactInfoLength(),
    );
    _o.bankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
      this.bankPermissions.bind(this),
      this.bankPermissionsLength(),
    );
    _o.liftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
      this.liftPermissions.bind(this),
      this.liftPermissionsLength(),
    );
    _o.floorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
      this.floorPermissions.bind(this),
      this.floorPermissionsLength(),
    );
    _o.actionFiringMode = this.actionFiringMode();
  }

  unpackFields(...fields: string[]): UserT {
    const t = new UserT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("role_id")) {
      t.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    }
    if (fieldSet.has("cognito_id")) {
      t.cognitoId = this.cognitoId() !== null ? this.cognitoId()!.unpack() : null;
    }
    if (fieldSet.has("pref_grid_id")) {
      t.prefGridId = this.prefGridId() !== null ? this.prefGridId()!.unpack() : null;
    }
    if (fieldSet.has("email")) {
      t.email = this.email();
    }
    if (fieldSet.has("first_name")) {
      t.firstName = this.firstName();
    }
    if (fieldSet.has("middle_name")) {
      t.middleName = this.middleName();
    }
    if (fieldSet.has("last_name")) {
      t.lastName = this.lastName();
    }
    if (fieldSet.has("status")) {
      t.status = this.status();
    }
    if (fieldSet.has("pref_theme")) {
      t.prefTheme = this.prefTheme();
    }
    if (fieldSet.has("offline_psw")) {
      t.offlinePsw = this.offlinePsw();
    }
    if (fieldSet.has("accepted_terms")) {
      t.acceptedTerms = this.acceptedTerms();
    }
    if (fieldSet.has("schedule_json")) {
      t.scheduleJson = this.scheduleJson();
    }
    if (fieldSet.has("created_offline_psw")) {
      t.createdOfflinePsw = this.createdOfflinePsw();
    }
    if (fieldSet.has("command_notifications")) {
      t.commandNotifications = this.commandNotifications();
    }
    if (fieldSet.has("global_notifications")) {
      t.globalNotifications = this.globalNotifications();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("org_type")) {
      t.orgType = this.orgType();
    }
    if (fieldSet.has("org_name")) {
      t.orgName = this.orgName();
    }
    if (fieldSet.has("role_name")) {
      t.roleName = this.roleName();
    }
    if (fieldSet.has("role_menu")) {
      t.roleMenu = this.roleMenu() !== null ? this.roleMenu()!.unpack() : null;
    }
    if (fieldSet.has("contact_info")) {
      t.contactInfo = this.bb!.createObjList<ContactInfo, ContactInfoT>(
        this.contactInfo.bind(this),
        this.contactInfoLength(),
      );
    }
    if (fieldSet.has("bank_permissions")) {
      t.bankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.bankPermissions.bind(this),
        this.bankPermissionsLength(),
      );
    }
    if (fieldSet.has("lift_permissions")) {
      t.liftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.liftPermissions.bind(this),
        this.liftPermissionsLength(),
      );
    }
    if (fieldSet.has("floor_permissions")) {
      t.floorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.floorPermissions.bind(this),
        this.floorPermissionsLength(),
      );
    }
    if (fieldSet.has("action_firing_mode")) {
      t.actionFiringMode = this.actionFiringMode();
    }
    return t;
  }
}

export class UserT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public roleId: UuidT | null = null,
    public cognitoId: UuidT | null = null,
    public prefGridId: UuidT | null = null,
    public email: string | Uint8Array | null = null,
    public firstName: string | Uint8Array | null = null,
    public middleName: string | Uint8Array | null = null,
    public lastName: string | Uint8Array | null = null,
    public status: UserStatus = UserStatus.NEW,
    public prefTheme: string | Uint8Array | null = null,
    public offlinePsw: string | Uint8Array | null = null,
    public acceptedTerms: string | Uint8Array | null = null,
    public scheduleJson: string | Uint8Array | null = null,
    public createdOfflinePsw: boolean = false,
    public commandNotifications: boolean = true,
    public globalNotifications: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public orgType: string | Uint8Array | null = null,
    public orgName: string | Uint8Array | null = null,
    public roleName: string | Uint8Array | null = null,
    public roleMenu: RoleMenuT | null = null,
    public contactInfo: ContactInfoT[] = [],
    public bankPermissions: RoleBankPermissionT[] = [],
    public liftPermissions: RoleLiftPermissionT[] = [],
    public floorPermissions: RoleFloorPermissionT[] = [],
    public actionFiringMode: ActionFiringMode = ActionFiringMode.INHERIT,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.roleId === null || this.roleId === undefined) {
      throw new Error('Required field "role_id" is not set');
    }
    if (this.email === null || this.email === undefined) {
      throw new Error('Required field "email" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const roleId = this.roleId !== null ? this.roleId!.pack(builder) : 0;
    const cognitoId = this.cognitoId !== null ? this.cognitoId!.pack(builder) : 0;
    const prefGridId = this.prefGridId !== null ? this.prefGridId!.pack(builder) : 0;
    const email = this.email !== null ? builder.createString(this.email!) : 0;
    const firstName = this.firstName !== null ? builder.createString(this.firstName!) : 0;
    const middleName = this.middleName !== null ? builder.createString(this.middleName!) : 0;
    const lastName = this.lastName !== null ? builder.createString(this.lastName!) : 0;
    const prefTheme = this.prefTheme !== null ? builder.createString(this.prefTheme!) : 0;
    const offlinePsw = this.offlinePsw !== null ? builder.createString(this.offlinePsw!) : 0;
    const acceptedTerms =
      this.acceptedTerms !== null ? builder.createString(this.acceptedTerms!) : 0;
    const scheduleJson = this.scheduleJson !== null ? builder.createString(this.scheduleJson!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const orgType = this.orgType !== null ? builder.createString(this.orgType!) : 0;
    const orgName = this.orgName !== null ? builder.createString(this.orgName!) : 0;
    const roleName = this.roleName !== null ? builder.createString(this.roleName!) : 0;
    const roleMenu = this.roleMenu !== null ? this.roleMenu!.pack(builder) : 0;
    const contactInfo = User.createContactInfoVector(
      builder,
      builder.createObjectOffsetList(this.contactInfo),
    );
    const bankPermissions = User.createBankPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.bankPermissions),
    );
    const liftPermissions = User.createLiftPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.liftPermissions),
    );
    const floorPermissions = User.createFloorPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.floorPermissions),
    );

    User.startUser(builder);
    User.addId(builder, id);
    User.addOrgId(builder, orgId);
    User.addRoleId(builder, roleId);
    User.addCognitoId(builder, cognitoId);
    User.addPrefGridId(builder, prefGridId);
    User.addEmail(builder, email);
    User.addFirstName(builder, firstName);
    User.addMiddleName(builder, middleName);
    User.addLastName(builder, lastName);
    User.addStatus(builder, this.status);
    User.addPrefTheme(builder, prefTheme);
    User.addOfflinePsw(builder, offlinePsw);
    User.addAcceptedTerms(builder, acceptedTerms);
    User.addScheduleJson(builder, scheduleJson);
    User.addCreatedOfflinePsw(builder, this.createdOfflinePsw);
    User.addCommandNotifications(builder, this.commandNotifications);
    User.addGlobalNotifications(builder, this.globalNotifications);
    User.addCreatedAt(builder, createdAt);
    User.addUpdatedAt(builder, updatedAt);
    User.addDeletedAt(builder, deletedAt);
    User.addOrgType(builder, orgType);
    User.addOrgName(builder, orgName);
    User.addRoleName(builder, roleName);
    User.addRoleMenu(builder, roleMenu);
    User.addContactInfo(builder, contactInfo);
    User.addBankPermissions(builder, bankPermissions);
    User.addLiftPermissions(builder, liftPermissions);
    User.addFloorPermissions(builder, floorPermissions);
    User.addActionFiringMode(builder, this.actionFiringMode);

    return User.endUser(builder);
  }

  clone(): UserT {
    const obj = new UserT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.roleId = this.roleId !== null ? this.roleId!.clone() : null;
    obj.cognitoId = this.cognitoId !== null ? this.cognitoId!.clone() : null;
    obj.prefGridId = this.prefGridId !== null ? this.prefGridId!.clone() : null;
    obj.email = this.email;
    obj.firstName = this.firstName;
    obj.middleName = this.middleName;
    obj.lastName = this.lastName;
    obj.status = this.status;
    obj.prefTheme = this.prefTheme;
    obj.offlinePsw = this.offlinePsw;
    obj.acceptedTerms = this.acceptedTerms;
    obj.scheduleJson = this.scheduleJson;
    obj.createdOfflinePsw = this.createdOfflinePsw;
    obj.commandNotifications = this.commandNotifications;
    obj.globalNotifications = this.globalNotifications;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.orgType = this.orgType;
    obj.orgName = this.orgName;
    obj.roleName = this.roleName;
    obj.roleMenu = this.roleMenu !== null ? this.roleMenu!.clone() : null;
    obj.contactInfo = this.contactInfo.map((e) => e.clone());
    obj.bankPermissions = this.bankPermissions.map((e) => e.clone());
    obj.liftPermissions = this.liftPermissions.map((e) => e.clone());
    obj.floorPermissions = this.floorPermissions.map((e) => e.clone());
    obj.actionFiringMode = this.actionFiringMode;
    return obj;
  }

  equals(other: UserT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.roleId !== null && other.roleId !== null) {
      if (!this.roleId!.equals(other.roleId!)) return false;
    } else if (this.roleId !== other.roleId) return false;
    if (this.cognitoId !== null && other.cognitoId !== null) {
      if (!this.cognitoId!.equals(other.cognitoId!)) return false;
    } else if (this.cognitoId !== other.cognitoId) return false;
    if (this.prefGridId !== null && other.prefGridId !== null) {
      if (!this.prefGridId!.equals(other.prefGridId!)) return false;
    } else if (this.prefGridId !== other.prefGridId) return false;
    if (this.email !== other.email) return false;
    if (this.firstName !== other.firstName) return false;
    if (this.middleName !== other.middleName) return false;
    if (this.lastName !== other.lastName) return false;
    if (this.status !== other.status) return false;
    if (this.prefTheme !== other.prefTheme) return false;
    if (this.offlinePsw !== other.offlinePsw) return false;
    if (this.acceptedTerms !== other.acceptedTerms) return false;
    if (this.scheduleJson !== other.scheduleJson) return false;
    if (this.createdOfflinePsw !== other.createdOfflinePsw) return false;
    if (this.commandNotifications !== other.commandNotifications) return false;
    if (this.globalNotifications !== other.globalNotifications) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.orgType !== other.orgType) return false;
    if (this.orgName !== other.orgName) return false;
    if (this.roleName !== other.roleName) return false;
    if (this.roleMenu !== null && other.roleMenu !== null) {
      if (!this.roleMenu!.equals(other.roleMenu!)) return false;
    } else if (this.roleMenu !== other.roleMenu) return false;
    if (this.contactInfo.length !== other.contactInfo.length) return false;
    for (let i = 0; i < this.contactInfo.length; i++) {
      const a = this.contactInfo[i];
      const b = other.contactInfo[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankPermissions.length !== other.bankPermissions.length) return false;
    for (let i = 0; i < this.bankPermissions.length; i++) {
      const a = this.bankPermissions[i];
      const b = other.bankPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.liftPermissions.length !== other.liftPermissions.length) return false;
    for (let i = 0; i < this.liftPermissions.length; i++) {
      const a = this.liftPermissions[i];
      const b = other.liftPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.floorPermissions.length !== other.floorPermissions.length) return false;
    for (let i = 0; i < this.floorPermissions.length; i++) {
      const a = this.floorPermissions[i];
      const b = other.floorPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actionFiringMode !== other.actionFiringMode) return false;
    return true;
  }
}

export function verifyUser(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "org_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "role_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "email");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 22, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 32, 1);
    verifier.checkScalarField(tablePos, 34, 1);
    verifier.checkScalarField(tablePos, 36, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 50);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyRoleMenu(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyContactInfo);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleBankPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleLiftPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleFloorPermission);
      }
    }
    verifier.checkScalarField(tablePos, 60, 1);
  } finally {
    verifier.popDepth();
  }
}
